<template>
  <div class="text-center">
    <v-dialog v-model="visible" width="500" persistent="">
      <v-card>
        <v-card-title class="justify-left">
          <h1 class="headline primary--text text--accent-2">
            {{ getError('401', 'session_timeout_header') }}
          </h1>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5 pb-1"
          ><p class="pl-3">{{ getError('401', 'session_timeout_content') }}</p>
        </v-card-text>
        <v-divider class="py-1"></v-divider>
        <v-card-actions class="pr-3 pb-3">
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            class="white--text text-capitalize"
            @click="confirm"
            ><span>{{ getError('401', 'session_timeout_button') }}</span></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      visible: true
    }
  },
  methods: {
    ...mapActions(['logoutUser']),
    logout() {
      // logout and navigate to homepage
      return this.logoutUser().then(() => {
        this.$router.push({ name: 'homepage' })
      })
    },
    hide() {
      this.visible = false
    },
    confirm() {
      this.hide()
      this.logout()
    },
    getError: function(errorKey, dummyRoute) {
      // there is no real route, so use dummyRoute
      return this.$store.getters.error({
        errorKey: errorKey,
        route: dummyRoute
      })
    }
  }
}
</script>
